import { useMutation, useQueryClient } from 'react-query'

import { DeduplicationService } from '../services'

export const useStartDeduplicationRun = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (objectType: 'company' | 'contact') => DeduplicationService.startRun(objectType),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['deduplication-runs'])
      },
    }
  )
}
